import { getShapeTransfomer } from "../../components/Editor/util/shapeCategorySingleton";
import { validShapeTypes } from "../../store/model";
interface UserData {
    type: 'userData'
}
export type ImportGeometricShape = GeometricShape & { layer: string }
export type ImportLineShape = LineShape & { lineType: number[] }
export type ImportDataType = ImportGeometricShape | ImportLineShape | UserData
export type JSONGeometricShape = GeometricShape & { rot?: number }

export function findUniquesLineTypes(ImportShapes: ImportDataType[]): LineType[] {
    const lineList = ImportShapes.map(element => {
        if (element.type === "line" || element.type === "polyline") {
            return element as ImportLineShape;
        }
        return undefined;
    });
    const uniqueTypes = getUniqueLineTypes(lineList.filter(x => x !== undefined) as ImportLineShape[])
    return uniqueTypes;
}

export function processParsedJSONProjectInformation(dataArray: ImportDataType[]): UserData | undefined {
    const customData = dataArray.find(isUserData)
    return customData;
}
function isUserData(data: ImportDataType): data is UserData {
    return data.type === "userData";

}

export function processParsedJSONToShapes(dataArray: ImportDataType[], uniqueLineTypes: LineType[]): GeometricShape[] {
    let internalShapeData = internalShapesFromJson(dataArray)
    internalShapeData = setSnappingPointsToShapes(internalShapeData)
    internalShapeData = transformToInternalFormat(internalShapeData)
    return reduceAndRenameLineTypeToDashID(internalShapeData, uniqueLineTypes);
}

function reduceAndRenameLineTypeToDashID(internalShapeDate: GeometricShape[], uniqueTypes: LineType[]): GeometricShape[] {
    return internalShapeDate.map((s) => {
        if (s.type === "line" || s.type === "polyline") {
            const { lineType, ...lineData } = s as ImportLineShape;

            return {
                ...lineData, dashID: uniqueTypes.findIndex((u) => {
                    console.log("stringek:", u.dash.toString(), "===", lineType?.toString());
                    return u.dash.toString() === lineType?.toString()
                })
            }
        } else {
            return s
        }
    });
}

export function findUniquesLayers(ImportShapes: ImportDataType[]): Layer[] {
    console.log(ImportShapes);

    const shape = ImportShapes.filter(isImportGeometricShape);
    console.log(shape);

    const layerSet = new Set(shape.map(s => s.layer))
    let tempId = 0;
    const layers: Layer[] = Array.from(layerSet).map(name => { return { name: name, visibility: true, id: tempId++ } })
    console.log("layers:", layers);

    return layers
}

function isImportGeometricShape(pet: ImportDataType): pet is ImportGeometricShape {
    return (pet as ImportGeometricShape).layer !== undefined;
}

function getUniqueLineTypes(line: ImportLineShape[]): LineType[] {
    // Store LineType number array as string to narrow it down
    const list = new Set(line.map(x => x.lineType?.toString()),);

    const defaultName = "importedLineType";

    // Set of LineType strings that are added to the list 
    let addedLineTypes: Set<string | undefined> = new Set();

    // Collecting the unique line definitons
    const lineList: LineType[] = line.map((a, i) => {
        if (!addedLineTypes.has(a.lineType?.toString())) {
            addedLineTypes.add(a.lineType?.toString());
            if (list.has(a.lineType?.toString())) {
                return {
                    name: defaultName + i,
                    id: i,
                    dash: a.lineType ?? []
                }

            }
        }
        return undefined;
    }).filter(x => x !== undefined) as LineType[]

    return lineList;
}

function setSnappingPointsToShapes(dataArray: GeometricShape[]): GeometricShape[] {
    const dataWithSnapPoints = dataArray.map((shape) => {
        return { ...shape, snapPoint: getShapeTransfomer(shape.type)?.snapPointCalculator(shape).snapPoint }
    })
    return dataWithSnapPoints;
}

function internalShapesFromJson(internalData: ImportDataType[]): GeometricShape[] {
    return internalData.filter((data) => {
        return data.type !== "userData"
    }) as GeometricShape[]
}

function isValidGeometricShapeType(shape: GeometricShape): shape is GeometricShape {
    const isValid = validShapeTypes.includes(shape.type as ShapeType);
    if (!isValid) console.error(shape.type, "type is not supported. supported type list: ", validShapeTypes);

    return isValid;
}

function transformToInternalFormat(internalShapeData: GeometricShape[]): GeometricShape[] {
    const validShapeList = internalShapeData.filter(isValidGeometricShapeType)
    const formatted = validShapeList.map((shape) => {
        const formatter = getShapeTransfomer(shape.type)
        if (formatter) {
            const afterFormat = { ...formatter.transformToInternalShape(shape), ...formatter.calculateWidthHeight(shape) }
            return afterFormat;
        } else {
            return shape
        }
    })
    return formatted
}

export const exportForImportTesting = { findUniquesLineTypes } 